import { createSelector } from '@reduxjs/toolkit'
import type { RegistrationData } from '../../model/registration'
import type { ConsumerAppSelector } from '../store'
import type { RegistrationState, WelcomeWithInitialLimitStatus } from './reducer'
import { getConsumerName } from '../account/consumer/helper'
import { Country } from '@afterpaytouch/portal-api/types'
import { ConsumerAddressType } from '@afterpay/types'

export const registrationSelector: ConsumerAppSelector<RegistrationState> = (state) => state.registration

export const registrationDataSelector: ConsumerAppSelector<RegistrationData | undefined> = createSelector(registrationSelector, (state) => state.data)

export const registrationConsumerNameSelector: ConsumerAppSelector<string> = createSelector(registrationSelector, (state) =>
  getConsumerName(state.data?.givenNames, state.data?.surname)
)

export const registrationConsumerGivenNameSelector: ConsumerAppSelector<string> = createSelector(registrationSelector, (state) => state.data?.givenNames ?? '')

export const registrationConsumerSurnameSelector: ConsumerAppSelector<string> = createSelector(registrationSelector, (state) => state.data?.surname ?? '')

export const registrationConsumerMobileSelector: ConsumerAppSelector<string> = createSelector(registrationSelector, (state) => state.data?.mobile ?? '')

export const registrationConsumerEmailSelector: ConsumerAppSelector<string> = createSelector(registrationSelector, (state) => state.data?.email ?? '')

export const registrationConsumerDateOfBirthSelector: ConsumerAppSelector<string> = createSelector(
  registrationSelector,
  (state) => state.data?.dateOfBirth ?? ''
)

export const registrationConsumerAddressSelector = createSelector(registrationSelector, (state) => ({
  postcode: state.data?.postcode ?? '',
  state: state.data?.state ?? '',
  suburb: state.data?.suburb ?? '',
  area2: state.data?.area2 ?? '',
  address1: state.data?.address1 ?? '',
  address2: state.data?.address2 ?? '',
  countryCode: state.data?.countryCode ?? Country.AU,
  id: 0,
  name: '',
  addressType: ConsumerAddressType.CONSUMER_ACCOUNT_CONTACT_ADDRESS,
}))

export const welcomeWithInitialLimitStatusSelector: ConsumerAppSelector<WelcomeWithInitialLimitStatus> = createSelector(
  registrationSelector,
  (state) => state.welcomeWithInitialLimitStatus
)
